import React from "react";

import { useFormikContext } from "formik";
import { useLocStore } from "../../localization";
import { LocContext } from "../../localization/LocContext";
import { CvpButton, CvpButtonProps } from "./CvpButton";
import styled from "styled-components";

interface CvpApplyWithConnectButtonProps extends CvpButtonProps {
  save?: boolean;
  send?: boolean;
  cancel?: boolean;
  delete?: boolean;
  submitType?: boolean;
}

export const CvpApplyWithConnectButton = (
  props: CvpApplyWithConnectButtonProps
) => {
  const { submitType, save, ...rest } = props;

  const L = useLocStore(LocContext.GENERAL);

  const btnLabel = save ? L.id("4adcb8beabcb").loc("Lagre") : "";

  const formik = useFormikContext();

  return (
    <StyledCvpApplyWithConnectButton
      type={submitType ? "submit" : "button"}
      disabled={submitType ? formik.isSubmitting : false}
      {...rest}
    >
      <div className="icons-container">
        <i className="pi pi-google" />
        <i className="pi pi-linkedin" />
        <i className="pi pi-apple" />
      </div>
      {btnLabel}
    </StyledCvpApplyWithConnectButton>
  );
};

export const StyledCvpApplyWithConnectButton = styled(CvpButton)`
  display: flex;
  align-items: center;
  gap: 1rem;

  .icons-container {
    display: flex;
    gap: 0.5rem;
  }
`;
